import * as React from 'react';
import './header.scss';

const Header = (props) => {
    return (
        <header>
            <h1>Herman Miller Brochures</h1>
            <p>SVG versions of Herman Miller trifold brochures from 1960 designed by George Nelson's studio (Irving Harper, Don Ervin, Tony Zamora, Dick Schiffer).</p>
            <p>See also:</p>
            <p><a href="http://projectobjectshop.com/hermanmiller-trifold#/id/i12535826">Set of 12 at Project Object</a>, <a href="http://www.javiergd.com/blog/?p=2341">Javier Garcia ephemera blog post</a></p>
        </header>
    )
}

export default Header;